export class WarehouseResponse {
	active: boolean;
	address: string;
	clientGroup: any;
	code: string;
	company: number;
	country: number;
	department: number;
	downloadEnabled: boolean
	email: string;
	establishmentCode: number;
	facebook: string;
	fcolor: string;
	gfaceEnabled: boolean;
	id: number;
	location: any;
	logo: string;
	manager: any;
	name: string;
	nfact: number;
	nit: string;
	number: number;
	page: string;
	scolor: string;
	slogan: string;
	sloganThree: string;
	sloganTwo: string;
	storeCategory: number;
	tcolor: string;
	town: number;
	twitter: string;
	maxCapacity: number;
	unitMeasureCapacity: string;
	type: number;
	ratio: number;
	length: number;
	diameter: number;
	height: number;
	width: number;
	place: number;

	constructor() {

	}
}

export class WarehouseCategoryResponse {
	id: number;
	category: string;
	constructor() {

	}
}

export class DepartmentResponse {
	country: number;
	id: number;
	name: string;

	constructor() {

	}
}

export class TownResponse {
	department: number;
	id: number;
	name: string;

	constructor() {

	}
}

export class CountryResponse {
	areaCode: number;
	fieldName: string;
	fieldType: string;
	id: number
	name: string;

	constructor(

	) {

	}
}

export class WarehouseRequest {
	code: string;
	number: number;
	name: string;
	country: number;
	department: number;
	town: number;
	address: string;
	manager: number;
	storeCategory: number;
	location: number;
	nit: string;
	email: string;
	page: string;
	facebook: string;
	twitter: string;
	logo: string;
	slogan: string;
	sloganTwo: string;
	sloganThree: string;
	gface!: boolean;
	establishmentCode!: number;
	maxCapacity: number;
	unitMeasureCapacity: string;
	type: number;
	ratio: number;
	length: number;
	diameter: number;
	height: number;
	width: number;
	place: number;

	constructor() {

	}
}